<template>
  <div>
    <a-badge
      count="Bản nháp"
      :number-style="{
        backgroundColor: '#fff',
        color: '#999',
        boxShadow: '0 0 0 1px #d9d9d9 inset',
      }"
      v-if="status === 'DRAFT'"
    />
    <a-badge
      count="Trình duyệt"
      :number-style="{
        backgroundColor: '#1890ff',
        color: '#fff',
      }"
      v-else-if="status === 'SUBMITTING'"
    />
    <a-badge
      count="Chỉnh sửa"
      :number-style="{
        backgroundColor: '#fdc032',
        color: '#fff',
      }"
      v-else-if="status === 'EDITING'"
    />
    <a-badge
      count="Đồng ý"
      v-else-if="status === 'APPROVED'"
      :number-style="{ backgroundColor: '#52c41a' }"
    />
    <a-badge count="Từ chối" v-else-if="status === 'REJECTED'" />
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
